import toastr from 'toastr'
import layout from 'layouts/default'

const components = {
  layout
}

const methods = {
  submit () {
    this.errors = {}
    this.processing = true;
    this.$store.dispatch('poi.newPOI', this.form)
    .then(() => {
      this.processing = false;
      let errors = this.$store.state.pointOfInterest.errors;
      if (errors) {
        if (errors.errors) {
          this.errors = _.cloneDeep(errors.errors);
        }        
        toastr.error(errors.message);
      } else {
        this.$router.replace({name: 'poi.all'});
      }
    });
  }
}

export default {
  name: 'new-poi',
  components,
  methods,
  data () {
    return {
      form: {
        name: null,
      },
      loading: false,
      processing: false,
      errors: {}
    }
  },
}
